export default {
  isLogin (state) {
    return Boolean(state.token)
  },
  bookingRemind ({ bindTicket }) {
    return bindTicket ? bindTicket.bookingRemind : ''
  },
  olciRemind ({ bindTicket }) {
    return bindTicket ? bindTicket.olciRemind : ''
  },
  userCoupon  (state) {
    return state.userCoupon || null
  },
  isFirstLogin (state) {
    return state.isFirstLogin
  },
  commonInfo (state) {
    return state.commonInfo
  },
  homePcpBindCouponInfo (state) {
    console.log('homePcpBindCouponInfo',  state.homePcpBindCouponInfo);
    return state.homePcpBindCouponInfo || null
  }
}
